import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { BasketUpsellReservationFormCTX } from '@basket/types/BasketUpsellReservationFormContext';
import { useContext } from 'preact/compat';
import { useCallback, useMemo, useState } from 'react';
import { OptionsCTX, optionsDefaults } from '@bookingForm/context/Options';
import defaultTheme from '@bookingForm/themes/default';
import BookingFormWrapper from '@genericBookings/components/BookingFormWrapper';
import { singleActivitySchema } from '@genericBookings/validation/schema';
import defaultValues from '@bookingForm/validation/defaultValues';
import StaticFormSteps from '@genericBookings/types/StaticFormSteps';
import Form from '@bookingForm/components/Form/Form';
import { useUpsellModal } from '@widgets/UpsellModal/UpsellModal';
import upsellTheme from '@bookingForm/themes/upsell';
import { Title } from '@widgets/UpsellModal/components/UpsellModalContent/styles';
function ReservationForm({ onComplete }) {
    const [showForm, setShowForm] = useState(false);
    const { setBackgroundVisible, setContentVisible } = useUpsellModal();
    const { bookingForm, formTitle, buttonText, } = useContext(BasketUpsellReservationFormCTX);
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...bookingForm,
        isMulti: false,
        isBuilder: false,
        debug: false,
        redirect: false,
        onComplete: () => {
            onComplete();
        },
    }), [bookingForm, onComplete]);
    const theme = {
        ...defaultTheme,
        ...upsellTheme,
        themeName: 'upsell',
        layout: 'rework',
    };
    const { productId, hideQuickPayButtons } = formOptions;
    const handleReservationFormStart = useCallback(() => {
        setShowForm(true);
        setContentVisible(false);
        setBackgroundVisible(false);
    }, [setShowForm, setContentVisible, setBackgroundVisible]);
    return (_jsxs(_Fragment, { children: [showForm && (_jsxs(BookingFormWrapper, { schema: singleActivitySchema, defaultValues: {
                    ...defaultValues,
                    ProductId: productId ?? 217,
                    acceptTerms: hideQuickPayButtons ? true : defaultValues.acceptTerms,
                }, steps: StaticFormSteps, theme: theme, OptionsCTX: OptionsCTX, options: formOptions, children: [formTitle && (_jsx(Title, { children: formTitle })), _jsx(Form, {})] })), !showForm && (_jsx("button", { className: "btn btn--full btn--primary", type: "button", onClick: handleReservationFormStart, children: buttonText }))] }));
}
export default ReservationForm;
